<HomeNavBar />
<div class="container-fluid p-3">
  <!-- Back Button -->


  <div v-if="loading" class="text-center py-5">
    <div class="spinner-border text-success" role="status"></div>
    <p class="mt-3">Loading checkout...</p>
  </div>
  <div v-else-if="cart && cart.items && cart.items.length" class="row justify-content-center">
    <div class="col-12 col-xl-10">
      <div class="card shadow-lg rounded-5 p-3 p-md-4 border-0">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-4">
          <div>
            <h4 class="text-primary fw-bold mb-1">Cart Summary</h4>
            <p class="text-muted mb-0">You have {{ cart.items.length }} item<span
                v-if="cart.items.length !== 1">s</span> in your cart.</p>
          </div>
          <div class="text-muted small">Review your items and confirm your order.</div>
        </div>

        <div class="row g-4">
          <div class="col-12 col-lg-8">
            <div class=" rounded shadow-sm p-4">
              <h5 class="fw-semibold mb-3">Products</h5>
              <div class="row g-3">
                <div v-for="item in cart.items" :key="item.id" class="col-12">
                  <div class="d-flex gap-3 align-items-center p-3 rounded-4 shadow-sm border bg-white cart-item-card">
                    <img v-if="item.product.images && item.product.images.length"
                      :src="item.product.images[0].image_url" alt="Product" class="cart-item-image rounded-3" />
                    <div class="flex-grow-1">
                      <h6 class="mb-1 fw-semibold">{{ item.product.name }}</h6>
                      <small class="text-muted">Quantity: {{ item.quantity }}</small>
                      <div
                        v-for="(attribute, index) in get_item_attributes(item)"
                        :key="`${item.id}-attribute-${index}`"
                        class="text-muted small"
                      >
                        {{ attribute.label }}: {{ attribute.value }}
                      </div>
                      <div class="text-muted small">{{format_currency(item.product.final_price ?? item.product.price)}}</div>
                      <div class="fw-semibold mt-1">Total: {{ format_currency((item.product.final_price ?? item.product.price) * item.quantity) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="checkout-section border-top pt-4 mt-4">
                <h6 class="checkout-section-title fw-bold text-dark text-uppercase mb-3">Fulfillment Method</h6>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <button
                      type="button"
                      class="fulfillment-card w-100"
                      :class="{ active: delivery_method === 'delivery' }"
                      @click="select_fulfillment_method('delivery')"
                    >
                      <span class="fulfillment-copy">
                        <span class="fulfillment-icon">
                          <i class="bi bi-truck"></i>
                        </span>
                        <span class="fulfillment-label fw-bold text-dark">Delivery</span>
                      </span>
                      <span class="fulfillment-price fw-bold">FREE</span>
                    </button>
                  </div>

                  <div class="col-12 col-md-6">
                    <button
                      type="button"
                      class="fulfillment-card w-100"
                      :class="{ active: delivery_method === 'pickup' }"
                      @click="select_fulfillment_method('pickup')"
                    >
                      <span class="fulfillment-copy">
                        <span class="fulfillment-icon">
                          <i class="bi bi-geo-alt"></i>
                        </span>
                        <span class="fulfillment-label fw-bold text-dark">Pickup</span>
                      </span>
                      <span class="fulfillment-price fw-bold">FREE</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="checkout-summary-panel bg-white rounded-4 shadow-sm p-4 position-sticky top-4">
              <h5 class="fw-semibold mb-3">Order Summary</h5>
              <div class="mb-3 d-flex justify-content-between align-items-center border-bottom pb-3">
                <span class="text-muted">Order Total</span>
                <span class="fw-bold">{{ format_currency(cart.total_amount) }}</span>
              </div>

              <div class="alert alert-warning py-2 px-3 text-xs mb-3 mb-md-4" role="alert">
                Your order must be accepted by the seller before you can proceed to payment.
              </div>
              <div v-if="payment_types.length" class="mb-3">
                <h6 class="checkout-section-title fw-bold text-dark text-uppercase mb-3">Payment Method</h6>
                <div class="row g-3">
                  <div v-for="payment_type in payment_types" :key="payment_type.id || payment_type.name" class="col-12 col-md-6">
                    <button
                      type="button"
                      class="btn w-100 rounded border d-flex align-items-center justify-content-start gap-2 py-3 px-3"
                      :class="is_payment_type_selected(payment_type) ? 'bg-primary border-secondary text-white' : 'bg-white border-light text-dark'"
                      :aria-pressed="is_payment_type_selected(payment_type) ? 'true' : 'false'"
                      @click="select_payment_type(payment_type)"
                    >
                      <span class="fw-bold">
                        {{
                          format_attribute_text(payment_type.name).toLowerCase() === 'pay now'
                            ? 'Pay'
                            : format_attribute_text(payment_type.name)
                        }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-grid gap-2 mt-4">
                <a href="/marketplace" class="btn btn-outline-secondary btn-sm rounded">Continue Shopping</a>
                <button v-if="!order_exists" class="btn btn-primary btn-sm rounded" @click="confirm_order"
                  :disabled="confirming_order">
                  <span v-if="confirming_order">
                    <i class="bi bi-arrow-repeat spin me-1"></i>
                    confirming...
                  </span>

                  <span v-else>
                    Confirm Order
                  </span>
                </button>
                <button v-else class="btn btn-secondary btn-sm rounded" disabled>
                  Waiting for Approval
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 <div v-else-if="cart_items && cart_items.length" class="row justify-content-center">
  <div class="col-12 col-xl-10">

    <div class="card shadow-lg rounded-5 p-3 p-md-4 border-0">

      <!-- HEADER -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-4">
        <div>
          <h4 class="text-primary fw-bold mb-1">Cart Summary</h4>
          <p class="text-muted mb-0">
            You have {{ cart_items.length }} item<span v-if="cart_items.length !== 1">s</span> in your cart.
          </p>
        </div>
        <div class="text-muted small">Review your items and confirm your order.</div>
      </div>

      <!-- ITEMS -->
      <div class="row g-4">
        <div class="col-12 col-lg-8">
          <div class="rounded shadow-sm p-4">
            <h5 class="fw-semibold mb-3">Products</h5>

            <div class="row g-3">
              <div v-for="item in cart_items" :key="item.id" class="col-12">

                <div class="d-flex gap-3 align-items-center p-3 rounded-4 shadow-sm border bg-white cart-item-card">

                  <img
                    v-if="item.product?.images?.length"
                    :src="item.product.images[0].image_url"
                    class="cart-item-image rounded-3"
                  />

                  <div class="flex-grow-1">
                    <h6 class="mb-1 fw-semibold">{{ item.product.name }}</h6>
                    <small class="text-muted">Quantity: {{ item.quantity }}</small>
                    <div
                      v-for="(attribute, index) in get_item_attributes(item)"
                      :key="`${item.id}-attribute-${index}`"
                      class="text-muted small"
                    >
                      {{ attribute.label }}: {{ attribute.value }}
                    </div>

                    <div class="fw-semibold mt-1">
                      Total: {{ format_currency((item.product.final_price ?? item.product.price) * item.quantity) }}
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div class="checkout-section border-top pt-4 mt-4">
                <h6 class="checkout-section-title fw-bold text-dark text-uppercase mb-3">Fulfillment Method</h6>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <button
                      type="button"
                      class="fulfillment-card w-100"
                      :class="{ active: delivery_method === 'delivery' }"
                      @click="select_fulfillment_method('delivery')"
                    >
                      <span class="fulfillment-copy">
                        <span class="fulfillment-icon">
                          <i class="bi bi-truck"></i>
                        </span>
                        <span class="fulfillment-label fw-bold text-dark">Delivery</span>
                      </span>
                      <span class="fulfillment-price fw-bold">FREE</span>
                    </button>
                  </div>

                  <div class="col-12 col-md-6">
                    <button
                      type="button"
                      class="fulfillment-card w-100"
                      :class="{ active: delivery_method === 'pickup' }"
                      @click="select_fulfillment_method('pickup')"
                    >
                      <span class="fulfillment-copy">
                        <span class="fulfillment-icon">
                          <i class="bi bi-geo-alt"></i>
                        </span>
                        <span class="fulfillment-label fw-bold text-dark">Pickup</span>
                      </span>
                      <span class="fulfillment-price fw-bold">FREE</span>
                    </button>
                  </div>
                </div>
              </div>

          </div>
        </div>

        <!-- SUMMARY -->
        <div class="col-12 col-lg-4">
          <div class="checkout-summary-panel bg-white rounded-4 shadow-sm p-4 position-sticky top-4">

            <h5 class="fw-semibold mb-3">Order Summary</h5>

            <div class="mb-3 d-flex justify-content-between align-items-center border-bottom pb-3">
              <span class="text-muted">Order Total</span>
              <span class="fw-bold">{{ format_currency(cart_total) }}</span>
            </div>

            <div class="alert alert-warning py-2 px-3 text-xs mb-3 mb-md-4">
              Your order must be accepted by the seller before you can proceed to payment.
            </div>
            <div v-if="payment_types.length" class="mb-3">
              <h6 class="checkout-section-title fw-bold text-dark text-uppercase mb-3">Payment Method</h6>
              <div class="row g-3">
                <div v-for="payment_type in payment_types" :key="payment_type.id || payment_type.name" class="col-12 col-md-6">
                  <button
                    type="button"
                    class="btn w-100 rounded border d-flex align-items-center justify-content-start gap-2 py-3 px-3"
                    :class="is_payment_type_selected(payment_type) ? 'bg-primary border-secondary text-white' : 'bg-white border-light text-dark'"
                    :aria-pressed="is_payment_type_selected(payment_type) ? 'true' : 'false'"
                    @click="select_payment_type(payment_type)"
                  >
                    <span class="fw-bold">
                      {{
                        format_attribute_text(payment_type.name).toLowerCase() === 'pay now'
                          ? 'Pay'
                          : format_attribute_text(payment_type.name)
                      }}
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="d-grid gap-2 mt-4">
              <a href="/marketplace" class="btn btn-outline-secondary btn-sm rounded">
                Continue Shopping
              </a>

              <button
                v-if="!order_exists"
                class="btn btn-primary btn-sm rounded"
                @click="confirm_order"
                :disabled="confirming_order"
              >
                <span v-if="confirming_order">
                  <i class="bi bi-arrow-repeat spin me-1"></i>
                  confirming...
                </span>

                <span v-else>
                  Confirm Order
                </span>
              </button>

              <button v-else class="btn btn-secondary btn-sm rounded" disabled>
                Waiting for Approval
              </button>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
  <div v-else-if="orders" class="container-fluid checkout-scroll">
    <div class="card border-0 shadow-sm rounded p-2 bg-white h-100 ">

    <div class="row justify-content-center">
      <div class="col-12 col-xl-11">
        <div class="row g-4 align-items-stretch">
          <!-- Left: Delivery Map -->
          <div class="col-12 col-lg-6 h-100 d-none">
            <div class="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
              <div class="card-body p-0">
                <Delivery v-if="orders" :key="orders.id" @update-delivery-fee="delivery_amount = $event"
                  @pickup-point-selected="update_pickup_point" />
              </div>
            </div>
          </div>

          <!-- Right: Cart Summary Panel -->
          <div class="col-12 h-100">
            <div>
              <!-- Header -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-bold text-dark mb-0">Cart Summary</h5>
              </div>
              <p class="text-muted small mb-4">The sum of all total payments for goods</p>

              <!-- Items List -->
              <div class="mb-4 pb-3">
                <div v-for="item in orders?.products" :key="item.id" class="mb-2 rounded border p-3">
                  <div class="d-flex align-items-center gap-3">
                    <img v-if="item?.product?.images && item?.product?.images.length"
                      :src="item?.product?.images[0]?.image_url" alt="Product" class="rounded-3 cart-item-img" width="60"
                      height="60" />
                    <div class="flex-grow-1 min-w-0">
                      <h6 class="fw-semibold text-dark mb-1 text-sm">{{ item?.product?.name }}</h6>
                      <small class="text-muted">Quantity: {{ item?.quantity }}</small>
                      <div
                        v-if="is_product_promo_applied_to_item(item)"
                        class="text-success text-xs fw-semibold mt-1"
                      >
                        Promo applied
                      </div>
                      <div
                        v-for="(attribute, index) in get_item_attributes(item)"
                        :key="`${item.id}-attribute-${index}`"
                        class="text-muted small"
                      >
                        {{ attribute.label }}: {{ attribute.value }}
                      </div>
                    </div>
                    <div class="text-end flex-shrink-0">
                      <div class="fw-bold">{{ format_currency(item?.total_price) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Order Details -->
              <div class="mb-4">
                <h6 class="fw-bold text-dark text-uppercase text-xxs mb-3 pb-2 border-bottom">Order Details</h6>
                <div class="d-flex justify-content-between mb-2 text-sm">
                  <span class="text-muted">Order Number</span>
                  <span class="fw-semibold text-xs">{{ orders?.order_number }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2 text-sm">
                  <span class="text-muted">Status</span>
                  <span class="fw-semibold text-xs">{{ orders?.order_status }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2 text-sm">
                  <span class="text-muted">Created</span>
                  <span class="fw-semibold text-xs">{{ format_date_time(orders?.created_at) }}</span>
                </div>
                <div v-if="selected_pickup_point" class="d-flex justify-content-between mb-2 text-sm">
                  <span class="text-muted">Delivery</span>
                  <span class="fw-semibold text-xs">{{ format_currency(delivery_amount) }}</span>
                </div>
              </div>

              <!-- Total -->
              <div class="checkout-total-section">
                <div class="mb-3">
                  <label class="form-label text-xxs fw-semibold text-muted">Promo Code</label>
                  <div class="input-group input-group-sm ">
                    <input
                      type="text"
                      class="form-control text-xxs"
                      placeholder="Enter product promo code"
                      v-model="product_promo_input"
                    />
                    <button
                      class="btn btn-primary text-xs"
                      type="button"
                      :disabled="!product_promo_input || is_applying_product_promo"
                      @click="apply_product_promo"
                    >
                      <span
                        v-if="is_applying_product_promo"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                      Apply
                    </button>
                  </div>
                  <p
                    v-if="product_promo_message"
                    :class="['text-xs mt-1 mb-0', product_promo_status === 'success' ? 'text-success' : 'text-danger']"
                  >
                    {{ product_promo_message }}
                  </p>
                </div>

                <div v-if="order_discount_amount > 0" class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-muted">Subtotal</span>
                  <span class="fw-semibold">{{ format_currency(get_order_original_total()) }}</span>
                </div>
                <div v-if="order_discount_amount > 0" class="d-flex justify-content-between align-items-center mb-2 text-success">
                  <span class="fw-semibold">Discount</span>
                  <span class="fw-bold">-{{ format_currency(order_discount_amount) }}</span>
                </div>
                <div v-if="selected_pickup_point" class="d-flex justify-content-between align-items-center mb-2">
                  <span class="text-muted">Delivery</span>
                  <span class="fw-semibold">{{ format_currency(delivery_amount) }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted fw-semibold">Total Amount</span>
                  <span class="fw-bold fs-5">{{ format_currency(total_with_delivery) }}</span>
                </div>
              </div>

              <!-- Payment Button -->
              <div class="checkout-payment-action d-grid">
                <button class="btn btn-primary fw-bold rounded py-3 w-100" @click="proceed_to_payment()">
                  PAY {{ format_currency(total_with_delivery) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="payment_form" :action="payfast" method="POST" class="d-none">
      <input type="submit" value="Submit" />
    </form>

    <input type="hidden" id="input_clone" class="d-none" />
  </div>
  </div>

</div>
